// extracted by mini-css-extract-plugin
export default {"btnpwd":"cfcfe4f7e2"};